import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    useCallback,
  } from "react";
  import { ApiService } from "./ApiService";
  
  export const CompanyAssignedContext = createContext();
  
  export const CompanyAssignedProvider = ({ children }) => {
    const [companyAssigned, setCompanyAssigned] = useState([]);
    const [companyLoading, setCompanyLoading] = useState(false);

    const fetchCompanyAssigned = useCallback(async () => {
      try {
        setCompanyLoading(true);
  
        const data = await ApiService.fetchData("api/company/my");
  
        if (data?.code && (data.code === 403 || data.code === 400)) {
          setCompanyAssigned([]); // limpiar si hay error
          return;
        }
  
        if (Array.isArray(data)) {
          setCompanyAssigned(data); 
        }
      } catch (err) {
        console.error("Error al conectar con el servidor", err);
      } finally {
        setCompanyLoading(false);
      }
    }, []);
  
    useEffect(() => {
      const current_page = String(window.location.pathname).split("/");
      if(current_page[1]=="administrar") fetchCompanyAssigned();
    }, [fetchCompanyAssigned]);
  
    return (
      <CompanyAssignedContext.Provider
        value={{
          companyAssigned,
          companyLoading,
          refreshCompanyAssigned: fetchCompanyAssigned,
        }}
      >
        {children}
      </CompanyAssignedContext.Provider>
    );
  };
  
  export const useCompanyAssigned = () => useContext(CompanyAssignedContext);
  